import ReactDOM from 'react-dom'
import videojs from 'video.js'
import React from 'react'

import PreviousVidIcon from '../../../../assets/codicons/video-icons/previous'

const vjsComponent = videojs.getComponent('Component')

class PreviousVid extends vjsComponent {
  constructor (player, options) {
    super(player, options)

    this.options = options

    player.ready(() => {
      this.mountElement()
    })

    /* Remove React root when component is destroyed */
    this.on('dispose', () => {
      ReactDOM.unmountComponentAtNode(this.el())
    })
  }

  mountElement () {
    ReactDOM.render(this.createPreviousButton(), this.el())
  }

  createPreviousButton () {
    return (
      <a href={this.options.url}>
        <PreviousVidIcon />
      </a>
    )
  }
}

vjsComponent.registerComponent('PreviousVid', PreviousVid)

export default PreviousVid
